import { createSelectorHooks } from 'auto-zustand-selectors-hook';
import { create } from 'zustand';

import { type MaterialType } from '$/services/usecases/materials/mapper/materials';
import { type MenuLayer } from '$/stores/useMaterialContextMenuStore';

export type FavoriteModalMode =
  | 'deleteFavorite'
  | 'renameFolder'
  | 'deleteFolder'
  | 'createFolder'
  | 'publishFolder'
  | 'hideFolder'
  | 'renameSection'
  | 'deleteSection';

type FavoriteModalProps = {
  isOpen: boolean;
  modalMode: FavoriteModalMode;
  itemIdentifier: string;
  itemName: string;
  itemType: MaterialType | undefined;
  menuLayer: MenuLayer | undefined;
  onClose: () => void;
  openFavoriteModal: (
    modalMode: FavoriteModalMode,
    itemIdentifier: string,
    itemName: string,
    itemType?: MaterialType,
    menuLayer?: MenuLayer,
  ) => void;
};

const store = create<FavoriteModalProps>()((set) => ({
  isOpen: false,
  modalMode: 'deleteFavorite',
  itemIdentifier: '',
  itemName: '',
  itemType: undefined,
  menuLayer: undefined,
  onClose: () => {
    set({ isOpen: false, itemName: '', itemIdentifier: '' });
  },
  openFavoriteModal: (
    mode,
    itemIdentifier,
    itemName,
    itemType,
    menuLayer = undefined,
  ) =>
    set({
      modalMode: mode,
      isOpen: true,
      itemIdentifier,
      itemType,
      itemName,
      menuLayer,
    }),
  saveAction: () => {},
}));

export const useFavoriteModal = createSelectorHooks(store);
